import { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { Flex, Box, Text, IconButton } from '@chakra-ui/react';
import CartModal from './CartModal';
import LoadingScreen from '../LoadingScreen';
import MenuCategory from './MenuCategory';

import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { TopMenuContext } from '../TopMenuContext';
import { setRestaurantID } from '../../Redux/Actions/Actions';
import { ImCalculator } from 'react-icons/im';

import { useDisclosure } from "@chakra-ui/react";

import './Styles/Menu.css';
import { categoriesToHashTable } from '../../utils/Categories Graph/CategoriesArrayToHashTable';

const mapStateToProps = (state) => {
    return {
        categoriesGraph: state.categoriesGraph,
        categoriesLU: categoriesToHashTable(state.categories),
        restaurantID: state.restaurantID,
        restaurant: state.restaurantInfo,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setID: (id) => {
            dispatch( setRestaurantID(id) );
        }
    }
}

const MenuPanel = (props) => {
    const [topMenuValues, setTopMenuValues] = useContext( TopMenuContext );

    let { categoryID, id } = useParams();
    let { setID } = props;
    let currentlySavedID = props.restaurantID;

    const { coveredIn, coveredOut } = props.restaurant || { };

    // NECESSARY, removing this causes infinite loading
    useEffect( ()=>{
        if( ! currentlySavedID )
            setID( id );
    }, [id, currentlySavedID, setID]);


    const { isOpen, onOpen, onClose } = useDisclosure();
    
    const { t } = useTranslation();
    
    return (
        <>
            { (!props.categoriesGraph) ?
                <section style={{height: "100vh", width: "100%", backgroundColor: "#FFF", position: "fixed", top: "0", left: "0", zIndex: "2"}}>
                    <LoadingScreen />
                </section>
            :

            <>
                <Flex ml={2} mr={2} mt="62px" direction="column">

                    <MenuCategory categoryKey={categoryID} depth={0} renderRecursive showIsOpen/>

                    {   (coveredIn || coveredOut) && 
                        <Text fontWeight="medium" fontSize="smaller" color="descriptiongrey" mt={5} ml={3}>
                            {
                                coveredIn && coveredOut ? 
                                    t("coverChargeIn") + ": "+ coveredIn + "€  - "+ t("coverChargeOut") + ': ' + coveredOut +'€' 
                                        :
                                    coveredIn ? t("coverChargeIn") + ": " + coveredIn + '€' 
                                                    :      
                                                t("coverChargeOut") + ': '+ coveredOut +'€'
                            }
                        </Text>   
                    }
                    <Box width="100%" height="1px" h={ (coveredIn || coveredOut) ? "70px": "130px" }></Box>
                    
                </Flex>

                
                { topMenuValues.stimaConto &&
                <>
                    <IconButton isRound 
                        variant="undecorated" 
                        icon={<ImCalculator/>} 
                        backgroundColor="highlight"
                        color="white"
                        size="lg"
                        fontSize="26px"
                        position="fixed"
                        top="82%"
                        left="82%"
                        boxShadow="0 1px 3px 0 rgb(0 0 0 / 72%),0 1px 2px 0 rgb(0 0 0 / 17%)"
                        onClick={ onOpen }
                        _focus={{ bg: "stronghighlight" }}
                    />

                    <CartModal isOpen={isOpen} onClose={onClose}/>
                </>
                }
            </>
        }
        </>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuPanel);